import * as Yup from 'yup'

const specialCharacters = '!@#$%^&*()_+-=[]{};:"\\|,.<>/?'

export const passwordValidation = (requiredMessage = 'Password is required') =>
    Yup.string()
        .required(requiredMessage)
        .min(8, 'Password must be 8-128 characters')
        .max(128, 'Password must be 8-128 characters')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[0-9]/, 'Password must contain at least one number')
        .test(
            'special-character',
            'Password must contain at least one special character',
            value => !value || [...value].some(character => specialCharacters.includes(character))
        )
